import { StrictMode, useEffect, useState } from "react"
import { createRoot } from "react-dom/client"
import { App } from "./app"

function Root() {
  const [, setLocationKey] = useState(currentLocationKey)

  useEffect(() => {
    const onPopState = () => {
      setLocationKey(currentLocationKey())
    }

    window.addEventListener("popstate", onPopState)
    return () => window.removeEventListener("popstate", onPopState)
  }, [])

  return <App pathname={window.location.pathname} search={window.location.search} />
}

function currentLocationKey(): string {
  return `${window.location.pathname}${window.location.search}`
}

const rootElement = document.getElementById("root")

if (!rootElement) {
  throw new Error("Root element #root was not found")
}

createRoot(rootElement).render(
  <StrictMode>
    <Root />
  </StrictMode>
)
